module.exports = __webpack_public_path__ + "static/media/app-brewery.56c5349b.png";